import type { PayloadAction } from "@reduxjs/toolkit";

export function isPayloadAction<T>(result: unknown): result is PayloadAction<T, string, unknown, unknown> {
    if (typeof result === "object" && result && "type" in result && "payload" in result) {
        return true;
    }

    return false;
}